import React from 'react'

const RightArrow = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M33.1172 19.8682L34.288 18.6974L35.4588 19.8682L34.288 21.039L33.1172 19.8682ZM8.28076 21.5239C7.36631 21.5239 6.625 20.7826 6.625 19.8682C6.625 18.9537 7.36631 18.2124 8.28076 18.2124V19.8682V21.5239ZM23.1826 9.93359L24.3534 8.76279L34.288 18.6974L33.1172 19.8682L31.9464 21.039L22.0118 11.1044L23.1826 9.93359ZM33.1172 19.8682L34.288 21.039L24.3534 30.9735L23.1826 29.8027L22.0118 28.6319L31.9464 18.6974L33.1172 19.8682ZM33.1172 19.8682V21.5239H8.28076V19.8682V18.2124H33.1172V19.8682Z" fill="#33363F" />
        </svg>

    )
}

export default RightArrow